import { useDispatch, useSelector } from 'react-redux';
import Modal from 'components/Modal/Modal';
import { setDialogState } from 'reduxStore/reducers/dialogSlice';
import ResetPasswordComponent from './component/ResetPassword';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  emailRegExp,
  enter_otp,
  reset_password,
  validation,
} from './constants/text';
import { forgotPassword, verifyOtp, signupOtp } from 'reduxStore/actions/auth';
import { useRef, useState } from 'react';
import { setToStorage } from 'utils/storage';
import { toast } from 'react-toastify';

const ResetPassword = () => {
  const { dialogOpenState } = useSelector((state) => state.dialogOpenState);
  const [email, setEmail] = useState('');
  const clearOtpRef = useRef(null);

  const signupEmail = localStorage.getItem('signupEmail');

  const dispatch = useDispatch();

  const isResetPasswordPage = dialogOpenState.resetPassword;
  const isSignupOtp = dialogOpenState.isSignupOtp;

  const formikEmail = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(emailRegExp, validation.email_valid)
        .required(validation.email_require),
    }),
    onSubmit: (values) => {
      sendEmailForOTP(values.email);
    },
  });

  const formikOTP = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .matches(/^\d{6}$/, validation.otp)
        .required(validation.otp_require),
    }),
    onSubmit: (values) => {
      onSubmit();
    },
  });

  const sendEmailForOTP = (emailValue) => {
    const params = {
      email: emailValue || formikEmail.values.email,
    };

    dispatch(forgotPassword(params))
      .unwrap()
      .then((response) => {
        setEmail(params.email);
        localStorage.setItem('email', params.email);

        dispatch(
          setDialogState({
            ...dialogOpenState,
            otp: true,
            resetPassword: false,
            isSignupOtp: false,
          })
        );
      })
      .catch((error) => {
        console.error('Error sending OTP:', error);
      });
  };

  const onSubmit = async ()  => {
    if (isSignupOtp) {
      const signupEmail = localStorage.getItem('signupEmail');

      const params = {
        otp: formikOTP.values.otp,
        email: signupEmail,
      };
    
      dispatch(signupOtp(params))
        .unwrap()
        .then((response) => {
          const data = response.data;
          setToStorage('accessToken', data.accessToken);
          setToStorage('refreshToken', data.refreshToken);
          localStorage.removeItem('signupEmail');

          dispatch(
            setDialogState({
              ...dialogOpenState,
              otp: false,
              isSignupOtp: false,
              logIn: false,
            })
          );
          if (response.success) {
            toast.success(response?.message || 'OTP Verified Successfully');
            // window.location.reload();
          }
        })
        .catch((error) => {
          const message =
            typeof error === 'string' ? error : 'Invalid OTP. Please try again.';
          formikOTP.setFieldError('otp', message);
          clearOtpRef.current?.();
        });
    } else {
      try {
        const storedEmail = localStorage.getItem('email');
        const params = {
          otp: formikOTP.values.otp,
          email: storedEmail || email || formikEmail.values.email,
        };
        const response = await dispatch(verifyOtp(params)).unwrap();

        if (response?.success) {
          dispatch(
            setDialogState({
              ...dialogOpenState,
              otp: false,
              newPassword: true,
            })
          );
        }
      } catch (error) {
        const message =
          typeof error === 'string' ? error : 'Invalid OTP. Please try again.';
        formikOTP.setFieldError('otp', message);
        clearOtpRef.current?.();
      }
    }
  };

  const cancelModal = () => {
    if (isResetPasswordPage) {
      dispatch(
        setDialogState({
          ...dialogOpenState,
          resetPassword: false,
          logIn: true,
        })
      );
    } else if (isSignupOtp) {
      // If it's signup OTP, go back to register
      localStorage.removeItem('signupEmail');
      dispatch(
        setDialogState({
          ...dialogOpenState,
          otp: false,
          isSignupOtp: false,
          register: true,
        })
      );
    } else {
      // For forgot password OTP, go back to reset password
      dispatch(
        setDialogState({
          ...dialogOpenState,
          resetPassword: true,
          otp: false,
        })
      );
    }
  };

  // const getDisplayEmail = () => {
  //   if (isSignupOtp) {
  //     return localStorage.getItem('signupEmail') || '';
  //   }
  //   return email || formikEmail.values.email;
  // };

  return (
    <Modal
      modalContentClassname={'sm:min-w-[490px] max-h-[90vh] overflow-y-auto sidebar-scrollbar '}
      title={isResetPasswordPage ? reset_password : enter_otp}
      disableOutsideClick={true}
      closeHandler={() => {
        if (isSignupOtp) {
          localStorage.removeItem('signupEmail');
        }
        dispatch(
          setDialogState({
            ...dialogOpenState,
            otp: false,
            resetPassword: false,
            isSignupOtp: false,
          })
        );
      }}
      text={
        isResetPasswordPage
          ? 'Enter your registered email address here to receive a OTP code to reset your password.'
          : `Please enter the 6-digit OTP Verification sent to <span className="font-[600] text-primary">${
              signupEmail || formikEmail.values.email
            }</span>`
      }
      children={
        <ResetPasswordComponent
          isResetPasswordPage={isResetPasswordPage}
          isSignupOtp={isSignupOtp}
          formikOTP={formikOTP}
          formikEmail={formikEmail}
          registerClearOtp={(clearOtp) => {
            clearOtpRef.current = clearOtp;
          }}
          onSubmit={(e) => {
            e.preventDefault();
            if (isResetPasswordPage) {
              formikEmail.handleSubmit();
            } else {
              formikOTP.handleSubmit();
            }
          }}
          continueModal={sendEmailForOTP}
          cancelModal={() => cancelModal()}
        />
      }
    />
  );
};

export default ResetPassword;
